import React from 'react';
import red from 'sushiweb/tokens/color/red';
import SpinnerCircular from 'sushiweb/Spinner/SpinnerCircular';
import { FOOD_AT_WORK_LOGO_IMG } from '../../../../constants/images';
import { LoaderContainer, ZLogoWrapper } from './styles';

const Loader = () => {
  return (
    <LoaderContainer className='center'>
      <ZLogoWrapper
        width='28.8rem'
        height='8.8rem'
        src={FOOD_AT_WORK_LOGO_IMG}
        alt='food-at-work'
      />
      <SpinnerCircular color={red.z_red} size='large' />
    </LoaderContainer>
  );
};

export default Loader;
